import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { OutsideClickHandler } from '../../components';

import css from './InfoTipForFields.module.css';

const IconTip = () => {

  return (
    <svg
      className={css.tipIcon}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <path d="M15 3C8.373 3 3 8.373 3 15s5.373 12 12 12 12-5.373 12-12S21.627 3 15 3zm1 18h-2v-7h2v7zm-1-9.5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0115 11.5z"></path>
    </svg>
  );
};

const InfoTipForFields = props => {
  const { rootClassName, className, tipId, tipText } = props;
  const classes = classNames(rootClassName || css.root, className);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <OutsideClickHandler className={css.outsideClickWrapper} onOutsideClick={() => setIsOpen(false)}>
      <div className={classes} onClick={() => setIsOpen(true)}>
        <IconTip />
        <p className={classNames(css.tipText, { [css.tipTextActive]: isOpen })}>
          <span>
            {tipText ? tipText : <FormattedMessage id={tipId} />}
          </span>
        </p>
      </div>
    </OutsideClickHandler>
  );
};

export default InfoTipForFields;
